import {assoc, reject, when} from 'ramda';
import {Key} from 'react';
import {AnyAction} from 'redux';

import {
  isCloseAllSnackbars,
  isCloseSnackbar,
  isCreateSnackbar,
  isDisplaySnackbar,
  isRemoveSnackbar
} from './actions';
import {
  SnackbarConfig,
  Snackbars
} from './state';

export const INITIAL_STATE: Snackbars = [];

const setDismissed = assoc('dismissed', true);
const setDisplayed = assoc('displayed', true);

const setDismissedWhenMatchesKey = (key: Key) => when((s: SnackbarConfig) => s.key === key, setDismissed);
const setDisplayedWhenMatchesKey = (key: Key) => when((s: SnackbarConfig) => s.key === key, setDisplayed);

export function notifications(state: Snackbars = INITIAL_STATE, action: AnyAction): Snackbars {
  if (isCreateSnackbar(action)) {
    return state.concat([{
      key: action.key,
      notification: action.notification
    }]);
  } else if (isCloseSnackbar(action)) {
    return state.map(setDismissedWhenMatchesKey(action.key));
  } else if (isCloseAllSnackbars(action)) {
    return state.map(setDismissed);
  } else if (isDisplaySnackbar(action)) {
    return state.map(setDisplayedWhenMatchesKey(action.key));
  } else if (isRemoveSnackbar(action)) {
    return reject(s => s.key === action.key, state);
  }

  return state;
}
